import { render, staticRenderFns } from "./listContent.vue?vue&type=template&id=efd54338&"
import script from "./listContent.vue?vue&type=script&lang=js&"
export * from "./listContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports